module.exports = __webpack_public_path__ + "static/mockup_redacted-a6051f7bee7e5342f2ceee3ef9bde980.svg";